import React,{useState} from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import { useDispatch,useSelector } from 'react-redux';
import './CustomDialog.scss'
import { rePerformKyc } from '../../../../../redux/authentication/actionCreator';

function RetryDialog  () {

  const dispatch = useDispatch();
  const referenceId = useSelector(state => state.auth.dialog.data.referenceId)
  const dialog = useSelector(state => state.auth.dialog)
  const title = useSelector(state => state.auth.dialog.title)
  const [open, setOpen] = useState(true)

  const handleClose = () => {
    const params = {
      clientCode : 'REFERRAL',
      referenceId : referenceId,
      url : null,
    };
    setOpen(false);
    dispatch(rePerformKyc(params));
  };

  return (
    <Dialog
      open={open}
      className="general-dialog"
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <div className="dialog-content">
        {
          dialog.category === 'information'?
          <img className="dialog-icon" alt="icon" src="/images/icon-information.svg"></img>
          :
          <img className="dialog-icon" alt="icon" src="/images/icon-error.svg"></img>

        }
        <p>{dialog.message} {title}</p>
        <Button variant="contained" className="btn-dialog"  onClick={handleClose}>
          Retry
        </Button>
      </div>

    </Dialog >
  )
}

export default RetryDialog;